import { removeAll } from '@leverege/array-util';
import { pathValue } from '@leverege/object-util';
import { options as colorOptions } from '../views/pairing/editor/ColorOption';
import { isVIN, removeNonVINCharacters } from '../util/VIN';
const DEFAULT_REPLACEMENTS = {
  silver: 'grey',
  blue: 'dark blue',
  green: 'dark green'
};
function replaceColor(data, color, optionsMap) {
  const trimmed = color?.trim().toLowerCase();
  const colorVal = optionsMap[trimmed];
  if (color && colorVal) {
    const nData = [...data];
    const len = nData.length;
    for (let i = 0; i < len; i++) {
      if (nData[i].path === 'color') {
        nData[i] = {
          path: 'color',
          value: colorVal.color
        };
        nData.push({
          path: 'colorName',
          value: colorVal.colorName
        });
        break;
      }
    }
    return nData;
  }
  removeAll(data, 'path', 'color');
  return data;
}
export default {
  processBlueprints(molten, blueprints) {
    const vehicle = blueprints.find(bp => bp.type === 'vehicle');
    if (vehicle) {
      const colorReplacements = {
        ...DEFAULT_REPLACEMENTS,
        ...(vehicle?.metadata?.colorReplacements || {})
      };
      const optionsMap = colorOptions.reduce((prev, option) => {
        const {
          value,
          name
        } = option;
        if (name.indexOf('/') !== -1) {
          const names = name.split('/');
          const mapVal = {
            colorName: name,
            color: value
          };
          prev[name] = mapVal;
          prev[name.toLowerCase()] = mapVal;
          names.forEach(n => {
            prev[n] = mapVal;
            prev[n.toLowerCase()] = mapVal;
          });
        } else {
          const mapVal = {
            colorName: name,
            color: value
          };
          prev[name] = mapVal;
          prev[name.toLowerCase()] = mapVal;
        }
        return prev;
      }, {});
      Object.entries(colorReplacements).forEach(([key, value]) => {
        if (optionsMap[value]) {
          optionsMap[key] = optionsMap[value];
        }
      });
      const plugin = {
        id: 'recovr.vehicle.BulkCreate',
        name: 'Bulk Create Vehicles Hook',
        matches: {
          objectType: 'vehicle'
        },
        hook(devs, props) {
          return devs.map(dev => {
            if (dev instanceof Error) {
              return dev;
            }
            const {
              data
            } = dev;
            const color = pathValue(data, 'color');
            const d = replaceColor(data, color, optionsMap);
            const vin = removeNonVINCharacters(pathValue(data, 'vin'));
            if (!isVIN(vin)) {
              return {
                error: 'Invalid VIN'
              };
            }
            return {
              ...dev,
              data: [...d]
            };
          });
        }
      };
      molten.addPlugin('BulkCreateHook', plugin);
    }
  }
};